import React from 'react';
import CustomTypography from '../../CustomTypography/CustomTypography';
import useStyles from './CustomStepperTrackingTextStyle';
var CustomStepperTrackingText = function (_a) {
    var modeloStep = _a.modeloStep;
    var styles = useStyles();
    var obtenerColorTitulo = function (colorTitulo) {
        switch (colorTitulo) {
            case 'verdeClaro':
                return styles.verdeClaro;
            case 'verdeOscuro':
                return styles.verdeOscuro;
            case 'rojo':
                return styles.rojo;
            case 'amarillo':
                return styles.amarillo;
            case 'grisL93':
                return styles.grisL93;
            case 'grisL83':
                return styles.grisL83;
            case 'grisL63':
                return styles.grisL63;
            case 'grisL43':
                return styles.grisL43;
            default:
                return styles.grisL63;
        }
    };
    return (React.createElement("section", { className: styles.textos },
        React.createElement(CustomTypography, { className: obtenerColorTitulo(modeloStep.colorTitulo), strong: "semi-bold", variant: "parrafo" }, modeloStep.titulo),
        React.createElement(CustomTypography, { className: obtenerColorTitulo(modeloStep.colorFecha), variant: "labelSmall" }, modeloStep.fecha)));
};
export default CustomStepperTrackingText;
